import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { useAuthQuery } from "../lib/api/auth";

export function ProtectedRoute() {
  const location = useLocation();
  const auth = useAuthQuery();

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-edlab-bg">
        <LoadingSpinner label="Checking session…" />
      </div>
    );
  }

  if (!auth.data) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
